import { createContext, useState } from "react";

export const DocumentContext = createContext();

export const DocumentProvider = ({ children }) => {
  const [uploadedCount, setUploadedCount] = useState(0);
  const [documentsState, setDocumentsState] = useState({}); // 👈 NEW

  return (
    <DocumentContext.Provider
      value={{
        uploadedCount,
        setUploadedCount,
        documentsState,
        setDocumentsState,
      }}
    >
      {children}
    </DocumentContext.Provider>
  );
};
